import { NgModule } from '@angular/core';
import { KpiStatsHostDirective } from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-stats-host.directive';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [SharedModule],
  declarations: [KpiStatsHostDirective],
  exports: [KpiStatsHostDirective],
})
export class KpiModule {}
